import React, { useRef } from 'react';
import Navbar from './Navbar';
import ContactForm from './ContactForm';

function App() {
  const formRef = useRef<HTMLDivElement>(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const services = [
    {
      title: 'LUZ Y GAS',
      subtitle: 'MEJORAMOS LAS CONDICIONES DE TU TARIFA',
      description: 'Nos adaptamos a TUS NECESIDADES.',
      extra: 'Asesoramiento Personalizado y Gratuito.',
      image: '/ahorro/img/card_1.png'
    },
    {
      title: 'MÓVIL E INTERNET',
      subtitle: 'ENCUENTRA LA MEJOR TARIFA DE MÓVIL E INTERNET',
      description: 'Ahorra en costes y aprovéchate de ofertas exclusivas para ti.',
      extra: 'Te ayudamos a encontrar la mejor tarifa.',
      image: '/ahorro/img/card_2.png'
    },
    {
      title: 'ALARMAS',
      subtitle: 'PROTEGE TU HOGAR O NEGOCIO',
      description: 'El coste dependerá de pequeños detalles.',
      extra: 'Te ayudaremos a encontrar la mejor opción en el mercado.',
      image: '/ahorro/img/card_3.png'
    }
  ];

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-[#E8C547]">
      <main className="container mx-auto px-4 py-12">
        <div className="text-center mb-16 py-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Ahorra en tus gastos del hogar</h2>
          <p className="text-xl text-gray-800 mb-2">¿Quieres ahorrar como yo?</p>
          <p className="text-lg text-gray-700">Te ayudamos a gestionar y reducir los gastos de tu hogar</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
              <img src={service.image} alt={service.title} className="w-full h-48 object-cover" />
              <div className="p-6">
                <h5 className="text-sm font-bold text-gray-900 mb-4">{service.title}</h5>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{service.subtitle}</h3>
                <p className="text-gray-800 mb-2">{service.description}</p>
                <p className="text-gray-800 mb-6">{service.extra}</p>
                <button onClick={scrollToForm} className="w-full bg-[#2D2D2D] hover:bg-black text-white font-semibold py-3 px-6 rounded-lg transition-all">
                  Pedir información
                </button>
              </div>
            </div>
          ))}
        </div>
      </main>

      <div ref={formRef} className="py-12">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-lg p-8 max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Rellena el formulario</h2>
            <p className="text-gray-600 mb-8">Completa tus datos y nos pondremos en contacto contigo para ofrecerte las mejores opciones de ahorro</p>
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default App;
